export default __webpack_public_path__ + "static/media/Email.6d02b8f5.svg";